<template>
  <div id="app" :class="{ navMargin: !$route.meta.hideNav }">
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
    <navbar v-if="!$route.meta.hideNav" />
    <notifications />
    <div v-if="jwt != ''">
      <WebSocket ref="websocket" class="websocket"
      :token="{jwt}" @receivedMessageEvent="receivedMessageEvent"/>
    </div>
  </div>
</template>
<script>

import store from '@/store/index';
import bus from '@/utils/EventBus';
import { Auth } from 'aws-amplify';
import { AmplifyEventBus } from 'aws-amplify-vue';

import WebSocket from '@/components/WebSocket.vue';
import eruda from 'eruda';
import Navbar from './components/Navbar.vue';
import Notifications from './components/Notifications.vue';

export default {
  components: { Navbar, Notifications, WebSocket },
  computed: {
    jwt() {
      return store.getters.getToken;
    },
  },
  methods: {
    receivedMessageEvent(message) {
      bus.$emit('receivedMessageEvent', message);
    },
    setupConsoleColours() {
      console.red = (str) => { console.log(`%c${str}`, 'color: black; background-color: red;'); };
      console.yellow = (str) => {
        console.log(`%c${str}`,
          'color: black; background-color: yellow;');
      };
      console.green = (str) => {
        console.log(`%c${str}`,
          'color: black; background-color: green;');
      };
      console.blue = (str) => { console.log(`%c${str}`, 'color: blue;'); };
      console.cyan = (str) => { console.log(`%c${str}`, 'color: cyan;'); };
    },
  },
  mounted() {
    this.setupConsoleColours();

    if (process.env.NODE_ENV === 'development') {
      console.warn('ERUDA');
      eruda.default.init();
    }
    this.$store.dispatch('loadStateFromLocalStorage');
    if (localStorage.getItem('loggedIn')) {
      const auth = Auth.currentSession();
      auth.then((user) => {
        console.log('[Debug] User is already logged in');
        const token = user.getIdToken().getJwtToken();
        store.commit('setToken', token);
        store.commit('setLoggedIn', true);
        AmplifyEventBus.$emit('authState', 'signedIn');
        store.dispatch('googleAuth/checkAuthenticatedWithGoogle');
      });
      auth.catch((error) => {
        console.log('some kind of auth error', error);
        const email = localStorage.getItem('email');
        const appStats = localStorage.getItem('appStats');
        const deviceSelected = localStorage.getItem('deviceSelected');
        const settings = localStorage.getItem('settings');
        localStorage.clear();
        if (email !== null) localStorage.setItem('email', email);
        if (appStats !== null) localStorage.setItem('appStats', appStats);
        if (deviceSelected !== null) localStorage.setItem('deviceSelected', deviceSelected);
        if (settings !== null) localStorage.setItem('settings', settings);
        this.$store.commit('setToken', '');
        this.$store.commit('setLoggedIn', false);
        this.$router.push('/');
      });
    }
  },

};
</script>
<style>

input::placeholder {
  color: #eaebecab;
  font-size: 16px;
}

input[type=text],
input[type=password],
input[type=email] {
  height: 50px;
  width: 250px;
  background: transparent;
  border: none;
  box-sizing: border-box;
  padding: 16px 0px 16px 16px;
  font-size: 16px;
}

.input {
  font-weight: bold;
  text-align: left;
  margin-top: 22px;
}
.input p {
  margin-left: 16px;
  margin-bottom: 6px;
}

input:-webkit-autofill{
  transition: background-color 5000000s ease-in-out 0s;
  -webkit-text-fill-color: var(--text) !important;

}
.input-container {
  display: flex;
  border-radius: var(--border-radius);
  background: var(--surface);
}

.websocket {
  display: none;
}
:root {
    --bg: black;
    --surface-dark: rgba(24, 26, 28, 0.9);
    --surface: rgba(48, 53, 56, 0.9);
    --surface-semilight: rgba(60, 66, 70, 0.9);
    --surface-light: rgba(72, 80, 84, 0.9);
    --surface-superlight: rgba(96, 106, 112, 0.9);

    --border-colour: rgba(255, 255, 255, 0.15);
    --border-style: 2px solid;
    --border: var(--border-style) var(--border-colour);
    --separator: 1px dashed rgba(255, 255, 255, 0.25);
    --shadow: 0 8px 24px rgba(0, 0, 0, 0.75);
    --border-radius: 5px;

    --modal-bg: rgba(0, 0, 0, 0.75);

    --accent: hsl(359, 100%, 68%);
    --accent-faint: hsla(359, 100%, 68%, 50%);

    --text: #eee;
    --text-faint: #888;

    --error: hsl(0, 70%, 50%);

    --success: hsl(120, 50%, 50%);
    --success-disabled: hsl(120, 10, 50, 1);
}

input[type=text],
input[type=password],
input[type=email] {
    font-family: 'Inter', Helvetica, Arial, sans-serif;

}
.bgSvg {
  background-repeat: no-repeat !important;
  background-position: center !important;
}

.fadeMenu-enter-active, .fadeMenu-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;

}
.fadeMenu-enter, .fadeMenu-leave-to {
  transform: translateY(-80px);
    opacity: 0;

}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

@import url('https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500&display=swap');
.html {
  overflow: hidden;
}
input {
  outline: none;
}

* {
  letter-spacing: 0.015em;
  -webkit-tap-highlight-color: transparent;
      font-family: 'Inter', Helvetica, Arial, sans-serif;
  margin: 0;
  padding: 0;
  color-scheme: dark;
}
html, body, #app {
  height: 100%;
  min-height: 100%;
}
body {
  background: var(--bg);
  overflow-x: hidden;
}
h1, h2, h3, p, button, input, span {
  color: var(--text);
}
input::placeholder {
  color: var(--text-faint)
}
a {
  color: var(--text);
  text-decoration: inherit;
}
#app {
  font-family: 'Inter', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
.radioFilter {
  margin-top: 40px;
  margin-left: 19px;
}
.button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 225px;
  height: 50px;
  border-radius: 100px;
  color: var(--text);
  font-size: 18px;
  transition: all 0.1s;
}
.buttonDefault {
  background-color: black;
}
.buttonRed {
  background-color: #e73232;
}
.buttonDefault:hover {
  background-color: #262626;
}
.buttonRed:hover {
  background-color: #ec5f5f;
}
button {
  cursor: pointer;
  border: none;
}
/* default button styles */
/* back button */
.back {
  position: absolute;
  top: 19px;
  left: 9px;
  width: 42px;
  height: 42px;
  background-repeat: no-repeat;
  background-position: center;
background-image: url("data:image/svg+xml,%3Csvg width='14' height='24' viewBox='0 0 14 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.25 22.5L1.75 12L12.25 1.5' stroke='%23EAEBEC' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");}
.backWhite {
  background-image: url("data:image/svg+xml,%3Csvg width='14' height='24' viewBox='0 0 14 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.25 22.5L1.75 12L12.25 1.5' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
}
/* back button */
/* different input types */
.input {
  outline: none;
  color: black;
  font-size: 16px;
  padding-left: 25px;
  padding-right: 10px;
  transition: all 0.1s;
}

.input1 {
  background: #ebebeb;

  border: var(--border);
  box-sizing: border-box;
  border-radius: var(--border-radius);
  height: 61px;
  width: 274px;
}
.input2 {
  height: 50px;
  width: 300px;
  background: white;
  border: var(--border);
  box-sizing: border-box;
  border-radius: var(--border-radius);
  filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.25));
}
.input1:focus {
  border: var(--border);
}
.input2:focus {
  border: var(--border);
  filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.35));
}

/* different input types */
</style>
